// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".betslip.shikisha .rounded-card{border:0}\n", "",{"version":3,"sources":["webpack://./src/components/Betslip/ShikishaBetBetslip.vue"],"names":[],"mappings":"AACA,gCAEE,QAAS","sourcesContent":["\n.betslip.shikisha {\n\t.rounded-card {\n\t\tborder: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
